import React, { createContext, useContext, useState, useCallback } from "react";
import { translations } from "./translations";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("goweb_lang") || "it");

  const changeLang = useCallback((l) => {
    localStorage.setItem("goweb_lang", l);
    setLang(l);
  }, []);

  const t = useCallback(
    (path) => {
      const parts = path.split(".");
      let node = translations[lang] || translations.it;
      for (const p of parts) {
        node = node?.[p];
        if (node === undefined) {
          // fallback to italian
          let f = translations.it;
          for (const q of parts) f = f?.[q];
          return f ?? path;
        }
      }
      return node;
    },
    [lang]
  );

  return <I18nContext.Provider value={{ lang, changeLang, t }}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
